<template lang="pug">
  div
    modal-projects(:form='selectedProject', :is-add='isModalProjectsAdd' :isVisible="isModalProjectsVisible" @closeModal="closeModalProjects")
    modal-concepts(:form='selectedConcept', :is-add='isModalConceptsAdd' :supplierName='null' :isVisible="isModalConceptsVisible" @closeModal="closeModalConcepts" @updateRecords="refreshMonthlyStatistics")
    modal-change-status(:form='selectedConcept' :concept="selectedConcept" :isVisible="isModalChangeStatusVisible" @closeModal="closeModalChangeStatus" @submit="updateStatus")
    div#header
      div.dashboard_title
        h2 {{ $t('strings.flows') }}
        img.title_icon(src="@/assets/file.png")
      div#buttons
        button.add_button(@click="showModalProjects")
          vm-icon(icon="plus-outline" size="1.4rem")
          span &nbsp; {{ $t('dashboard.new_project') }}
        button.add_button(@click="showModalConcepts")
          vm-icon(icon="plus-outline" size="1.3rem")
          span &nbsp; {{ $t('dashboard.concept') }}
    div
    vm-date-picker(type="month" :label="$t('dashboard.date')" :placeholder="$t('strings.select_date')" @on-change="selectMonthlyStatistic" v-model="date")
    div.statistics
      div.statistic
        div.side_color(style="background-color: #ff6b00")
        span.statistic_text {{ $t('dashboard.income')}}
        strong.statistic_number {{ monthlyStatistic.income | currency }}
      div.statistic
        div.side_color(style="background-color: #1cb7ff")
        span.statistic_text {{ $t('dashboard.expenses')}}
        strong.statistic_number {{ monthlyStatistic.expenses | currency }}
      div.statistic
        div.side_color(style="background-color: #5367ff")
        span.statistic_text  {{ $t('dashboard.difference')}}
        strong.statistic_number {{ monthlyStatistic.difference | currency }}
      div.statistic
        div.side_color(style="background-color: #15dd73")
        span.statistic_text {{ $t('dashboard.flows_balance')}}
        strong.statistic_number {{ monthlyStatistic.balance | currency }}
    br
    .income_header
      h3 {{ $t('dashboard.income') }} / {{ $t('dashboard.expenses') }}
      button.export_button(@click="exportConcepts")
        vm-icon(icon="cloud-download" size="1.4rem")
        span &nbsp; {{ $t('strings.export') }}
    vm-table.table(max-height="350px" :data="concepts")
      template(slot="thead")
        vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('concepts.' + column) }}
      template(slot-scope="{data}")
        vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
          vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
            slot(v-if="column == 'charge' || column == 'payment'")  {{ data[indextr][column] | currency }}
            slot(v-if="column == 'created_at' || column == 'date'")  {{ data[indextr][column] | moment("DD MMMM YYYY").toUpperCase() }}
            slot(v-if="column == 'conceptable_name'")  {{ data[indextr]['conceptable']['name'] }}
            slot(v-if="column == 'conceptable_type'")  {{ data[indextr][column] === 'App\\Models\\AdministrativeConcept' ? $t('dashboard.administrative') : data[indextr][column] == 'App\\Models\\Project' ? $t('dashboard.project') : $t('dashboard.supplier')}}
            slot(v-if="column != 'created_at' && column != 'conceptable_name' && column != 'date' && column != 'charge' && column != 'payment' && column != 'conceptable_type' && column != 'role' && column != 'total' && column != 'status' && column != 'unit_price'") {{ data[indextr][column] }}
            vm-status-indicator(v-if="column == 'status'" :pulse="true" :color="statusColor(data[indextr][column])") {{data[indextr][column] === 1 ? $t('dashboard.payed') : $t('dashboard.invoiced')}}
          vm-td
          vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click v-if="isConceptValid(data[indextr]) == 1")
            vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
            vm-dropdown-menu(style="width: 12rem")
              vm-dropdown-item.d-flex.justify-content-between(@click="showModalChangeStatus(data[indextr])")
                vm-icon(icon="checkmark-circle-outline")
                slot &nbsp;{{ $t('strings.change_status') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="editSelectedRecord(data[indextr])")
                vm-icon(icon="edit-2-outline")
                slot &nbsp;{{ $t('strings.edit') }}
              vm-dropdown-item.d-flex.justify-content-between(@click="deleteConceptConfirm(data[indextr])")
                vm-icon(icon="trash-2-outline")
                slot &nbsp;{{ $t('strings.delete') }}
              //- More actions
    vm-pagination(:total="conceptsPagination.totalPages" v-model="currentPage" goto)
</template>
<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')
const ModalProjects = () => import('@/components/modals/ModalProjects.vue')
const ModalConcepts = () => import('@/components/modals/ModalConcepts.vue')
const ModalChangeStatus = () => import('@/components/modals/ModalChangeConceptStatus.vue')

export default {
  name: 'Concepts',
  components: {
    ModalProjects,
    ModalConcepts,
    ModalChangeStatus
  },
  mixins: [ModalMixin1],
  data: () => ({
    currentPage: 1,
    date: moment().format('YYYY-MM'),
    records: [],
    columns: [
      'date',
      'conceptable_type',
      'conceptable_name',
      'concept',
      'payment',
      'charge',
      'status'
    ],
    isModalConceptsVisible: false,
    isModalConceptsAdd: true,

    isModalProjectsVisible: false,
    isModalProjectsAdd: true,
    isModalChangeStatusVisible: false,
    selectedProject: {},
    selectedConcept: {
      date: moment().format('YYYY-MM-DD'),
      conceptable_type: '',
      conceptable_id: '',
      concept: '',
      payment: 0,
      charge: 0,
      status: 1
    },
    filters: {
      byMonth: '',
      byYear: ''
    },
    attributeModal: 'concept'
  }),
  computed: {
    ...mapGetters([
      'concepts',
      'conceptsPagination',
      'monthlyStatistic',
      'filterParams'
    ])
  },
  watch: {
    filterParams () {
      this.loadConcepts({ page: this.currentPage })
    },
    async currentPage (value) {
      this.loadConcepts({ page: value })
    },
    concepts (data) {
      this.records = data
    }
  },
  async created () {
    const date = moment()
    this.filters = {
      byYear: `date,${date.format('YYYY')}`,
      byMonth: `date,${date.format('MM')}`
    }
    this.applyFilter(this.filters)

    await this.loadMonthlyStatistic({
      year: date.format('YYYY'),
      month: date.format('MM')
    })
    await this.loadConcepts({ page: this.currentPage })
  },
  methods: {
    ...mapActions([
      'editConcept',
      'deleteRecord',
      'loadConcepts',
      'loadMonthlyStatistic',
      'applyFilter',
      'setDateAlert',
      'exportConcepts'
    ]),
    isConceptValid (concept) {
      return ((moment(concept.date).format('YYYY-MM') === moment().format('2022-12') || moment(concept.date).format('YYYY') > 2022)) ? 1 : 0
    },
    refreshMonthlyStatistics () {
      setTimeout(async () => {
        await this.loadMonthlyStatistic({
          year: this.monthlyStatistic.year,
          month: this.monthlyStatistic.month
        })
      }, 1000)
    },
    selectMonthlyStatistic (value) {
      if ((moment(value).format('YYYY-MM') === 2021 && moment(value).format('MM') > 6) ||
      (moment(value).format('YYYY') === moment().format('YYYY') && moment(value).format('MM') <= moment().format('MM')) ||
      (moment(value).format('YYYY') < moment().format('YYYY') && moment(value).format('YYYY') > 2021)) {
        this.filters = {
          byYear: `date,${value.split('-')[0]}`,
          byMonth: `date,${value.split('-')[1]}`
        }
        this.loadMonthlyStatistic({
          year: value.split('-')[0],
          month: value.split('-')[1]
        })
      } else {
        this.loadMonthlyStatistic({
          year: moment().format('YYYY'),
          month: moment().format('MM')
        })
        this.filters = {
          byYear: `date,${moment().format('YYYY')}`,
          byMonth: `date,${moment().format('MM')}`
        }
        this.setDateAlert()
        this.date = moment().format('YYYY-MM-DD')
      }
      this.applyFilter(this.filters)
    },
    showModalProjects () {
      this.isModalProjectsVisible = true
      this.isModalProjectsAdd = true
    },
    showModalConcepts () {
      this.isModalConceptsAdd = true
      this.isModalConceptsVisible = true
      this.selectedConcept = {
        date: moment().format('YYYY-MM-DD'),
        payment: 0,
        charge: 0
      }
    },
    showModalChangeStatus (concept) {
      this.selectedConcept = { ...concept }
      this.isModalChangeStatusVisible = true
    },
    statusColor (status) {
      return status === 1 ? 'success' : 'warning'
    },
    closeModalConcepts () {
      this.isModalConceptsVisible = false
      this.refreshMonthlyStatistics()
    },
    closeModalProjects () {
      this.isModalProjectsVisible = false
      this.selectedProject = {}
    },

    closeModalChangeStatus () {
      this.isModalChangeStatusVisible = false
    },
    async updateStatus (form) {
      await this.editConcept({ ...this.selectedConcept, ...form })
      this.refreshMonthlyStatistics()
    },
    async deleteConceptConfirm (record) {
      let t = this
      this.auxDeleteRecord = async () => {
        await t
          .deleteRecord({ ...record, route: 'concepts', type: 'CONCEPT' })
          .then(() => {
            t.selected = []
          })
        await t.refreshMonthlyStatistics()
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation2', {
          model: this.$t('strings.' + this.snakeCaseSingular),
          attribute: this.$t(record[this.attributeModal])
        }),
        accept: this.auxDeleteRecord
      })
    },
    editSelectedRecord (record) {
      this.selectedConcept = { ...record, payment: parseFloat(record.payment).toFixed(2), charge: parseFloat(record.charge).toFixed(2) }
      this.isModalConceptsAdd = false
      this.isModalConceptsVisible = true
    }
  }
}
</script>
<style scoped lang="scss">
@import "./dashboard_structure.css";
#header {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
#buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
